module.exports = __webpack_public_path__ + "static/media/newwebbg.9022e2ae.jpg";